import { querySelectorAll } from '../helpers'

export function initializeSortSelect() {
  querySelectorAll<HTMLSelectElement>('select[name="sort"]').forEach(select => {
    const form = select.closest('form') as HTMLFormElement
    if (form) {
      select.addEventListener('change', () => {
        form.submit()
      })
    }
  })
}
